// 计算两个时间之差
export function getTimeDifference (startTime, endTime) {
  let start = (new Date(startTime)).getTime() // 传过来的开始时间转换为毫秒
  let end = (new Date(endTime)).getTime()
  if (parseInt(end) <= parseInt(start)) {
    return '0' // 结束时间小于等于开始时间
  }
  let days = parseInt(Math.abs(start - end) / 1000 / 60 / 60 / 24)
  if (days > 0) {
    return days + '天'
  }
  let hours = parseInt(Math.abs(start - end) / 1000 / 60 / 60)
  if (hours > 0) {
    return hours + '小时'
  }
  let minites = parseInt(Math.abs(start - end) / 1000 / 60)
  if (minites > 0) {
    return minites + '分钟'
  }
  let second = parseInt(Math.abs(start - end) / 1000)
  if (second > 0) {
    return second + '秒'
  }
}

// 计算档期发布天数
export function GetPublishDay (startTime, endTime) {
  let start = (new Date(startTime)).getTime() // 传过来的开始时间转换为毫秒
  let end = (new Date(endTime)).getTime()
  if (parseInt(end) <= parseInt(start)) {
    return '' // 结束时间小于等于开始时间
  }
  let days = parseInt(Math.abs(start - end) / 1000 / 60 / 60 / 24)
  if (days > 0) {
    return days + 1 + '天'
  }
}

// 获取某日期N天后的日期
export function GetDateStr (startDate, AddDayCount) {
  var dd = new Date(startDate)
  dd.setDate(dd.getDate() + AddDayCount - 1)// 获取AddDayCount天后的日期
  var y = dd.getFullYear()
  var m = (dd.getMonth() + 1) < 10 ? '0' + (dd.getMonth() + 1) : (dd.getMonth() + 1)// 获取当前月份的日期，不足10补0
  var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate()// 获取当前几号，不足10补0
  return y + '-' + m + '-' + d
}

// 获取当前可用的常规档期
export function GetSchedule () {
  var nowDate = new Date()
  var nowDay = nowDate.getDate()
  var nowMonth = nowDate.getMonth() + 1
  var nowYear = nowDate.getFullYear()
  var scheduleStr = [' 上', ' 下']
  var seperator1 = '-'
  var seperatorDay = 15
  var schedules = []
  var allMonth = 12
  if (nowDay < seperatorDay) { // 可以买当月下的档期
    var monthstr = ''
    if (nowMonth >= 1 && nowMonth <= 9) {
      monthstr = '0' + nowMonth
    } else {
      monthstr = nowMonth
    }
    schedules.push({ label: nowYear + seperator1 + monthstr + ' 下', value: nowYear + seperator1 + monthstr + seperator1 + '15' })
    allMonth -= 1
  }
  for (var i = 1; i <= allMonth; i++) {
    var year = nowYear
    var month = nowMonth + i
    if (month > 12) {
      month = month - 12
      year += 1
    }
    if (month >= 1 && month <= 9) {
      month = '0' + month
    }
    for (var j = 0; j < scheduleStr.length; j++) {
      var strDate = scheduleStr[j] === ' 上' ? '01' : '15'
      schedules.push({ label: year + seperator1 + month + scheduleStr[j], value: year + seperator1 + month + seperator1 + strDate })
    }
  }
  if (nowDay < seperatorDay) {
    var yearstr = nowYear + 1
    if (nowMonth >= 1 && nowMonth <= 9) {
      monthstr = '0' + nowMonth
    }

    schedules.push({ label: yearstr + seperator1 + monthstr + ' 上', value: yearstr + seperator1 + monthstr + seperator1 + '01' })
    allMonth -= 1
  }
  return schedules
}

// 获取当前月份
export function GetCurrentMonth () {
  var nowDate = new Date()
  var nowMonth = nowDate.getMonth() + 1
  var nowYear = nowDate.getFullYear()
  var schedules = {}

  if (nowMonth === 12) {
    schedules = { startDate: nowYear + '-12-01', endDate: (nowYear + 1) + '-01-01' }
  } else {
    schedules = { startDate: nowYear + '-' + nowMonth + '-01', endDate: nowYear + '-' + (nowMonth + 1) + '-01' }
  }
  return schedules
}

// 获取当前档期
export function GetCurrentSchedule (startDate, enddate) {
  var start = new Date(startDate)
  var end = new Date(enddate)
  var startDay = start.getDate()
  var endDay = end.getDate()

  var monthstr = ''
  var startMonth = start.getMonth() + 1
  var endMonth = end.getMonth() + 1
  if (startMonth >= 1 && startMonth <= 9) {
    monthstr = '0' + startMonth
  } else {
    monthstr = startMonth
  }
  var nowYear = start.getFullYear()

  if (startMonth !== endMonth) {
    return startDate + '至' + enddate
  }
  if (startDay === 1 && endDay === 14) {
    return nowYear + '-' + monthstr + ' 上'
  } else if (startDay === 15 && endDay === 28) {
    return nowYear + '-' + monthstr + ' 下'
  } else {
    return startDate + '至' + enddate
  }
}

/**
 * 格式化日期，
 * @param {*} date 要转换的日期，如果不是 Date 类型，则会抛出一个日期格式不正确的错误
 * @param {String} spliter 分隔符，默认是 ‘-’
 */
export function ParseDate (date, spliter = '-') {
  if (date === '') { return '' }

  const dateObj = new Date(date)
  if (dateObj instanceof Date) {
    return dateObj.getFullYear() + spliter +
        ((dateObj.getMonth() + 1) + '').padStart(2, '0') + spliter +
        (dateObj.getDate() + '').padStart(2, '0')
  } else {
    throw new Error('日期格式不正确')
  }
}

/**
   * 获取一个从开始时间相加若干个月之后的月初
   * @param {String} 开始时间
   * @param {Number} 月数
   */
export function addMonth (start, months) {
  const startDate = new Date(start)
  const year = startDate.getFullYear()
  const month = startDate.getMonth()
  startDate.setFullYear(year, month + months)
  return ParseDate(startDate)
}
